import { applyColorsToFields } from '@ardoq/dashboard';
import {
  removeManuallyAssignedColorForDataPoint,
  SetColorForDataPointPayload,
  selectBarChartColorSelection,
  selectNumberSlices,
  setColorForDataPoint,
  SelectBarChartColorSelection,
  SelectNumberSlicesPayload,
} from './actions';
import { getUpdatedWidgets } from './stateUtils';
import { reducer } from '@ardoq/rxbeach';
import { Widgets$State } from './types';

const setColorForDataPointInSettings = (
  state: Widgets$State,
  { dataPoint, color }: SetColorForDataPointPayload
): Widgets$State => ({
  ...state,
  settings: {
    ...state.settings,
    colors: state.settings.colors.map(dataColor =>
      dataColor.dataPoint === dataPoint
        ? {
            ...dataColor,
            color,
            isManuallyAssigned: true,
          }
        : dataColor
    ),
  },
});

const removeManuallyAssignedColorForDataPointAndApplyColors = (
  state: Widgets$State,
  dataPoint: string
): Widgets$State => ({
  ...state,
  settings: {
    ...state.settings,
    colors: applyColorsToFields({
      widgets: state.widgets,
      colors: state.settings.colors.filter(
        colorData => colorData.dataPoint !== dataPoint
      ),
      paletteColors: state.selectedColorPalette,
      rememberedColors: {},
    }),
  },
});

const selectBarChartColorSelectionAndApplyColors = (
  state: Widgets$State,
  { colorSelection, widgetId }: SelectBarChartColorSelection
): Widgets$State => {
  const widgets = getUpdatedWidgets(state.widgets, [
    { colorSelection, _id: widgetId },
  ]);

  return {
    ...state,
    widgets,
    settings: {
      ...state.settings,
      colors: applyColorsToFields({
        widgets,
        colors: state.settings.colors,
        paletteColors: state.selectedColorPalette,
        rememberedColors: {},
      }),
    },
  };
};

const setNumberSlices = (
  state: Widgets$State,
  { numberSlices, widgetId }: SelectNumberSlicesPayload
): Widgets$State => {
  const widgets = getUpdatedWidgets(state.widgets, [
    { numberSlices, _id: widgetId },
  ]);

  return {
    ...state,
    widgets,
    settings: {
      ...state.settings,
      colors: applyColorsToFields({
        widgets,
        colors: state.settings.colors,
        paletteColors: state.selectedColorPalette,
        rememberedColors: {},
      }),
    },
  };
};

export const colorSettingsReducers = [
  reducer(
    removeManuallyAssignedColorForDataPoint,
    removeManuallyAssignedColorForDataPointAndApplyColors
  ),
  reducer(
    selectBarChartColorSelection,
    selectBarChartColorSelectionAndApplyColors
  ),
  reducer(selectNumberSlices, setNumberSlices),
  reducer(setColorForDataPoint, setColorForDataPointInSettings),
];
